import React, { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AppRoutes from './routes/AppRoutes';
import { initialize, logout } from '../src/store/slices/userSlice';
import Toaster from './components/Toaster';
import ScrollToTop from './components/scrollTop';
import { checkTokenValidity, clearAuthData } from './utils/utils';

const App = () => {
  const dispatch = useDispatch();
  const routes = useRoutes(AppRoutes());

  useEffect(() => {
    // Load user and token from localStorage and initialize the state
    const user = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    const adresse_facturation = localStorage.getItem('adresse_facturation');
    
    console.log('Here', checkTokenValidity(token)) // false
    
    if (token && !checkTokenValidity(token)) {
      clearAuthData();
      dispatch(logout());
      return;
    }
    if (user && token) {
      dispatch(initialize({
        isAuthenticated: true,
        user: JSON.parse(user),
        adresse_facturation: adresse_facturation ? JSON.parse(adresse_facturation) : null,
        token,
      }));
    }
  }, [dispatch]);

  return <>
    <Toaster />
    <ScrollToTop />
    {routes}
  </>;
};

export default App;
